import React from 'react';
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

import "./AboutUs.css";
import ContactUs from "../Home/ContactUs/ContactUs"
import Process from "../Home/Process/Process"
import Header from "../Shared/Header/Header";
import SubHeader from '../Shared/SubHeader/SubHeader';
import Footer from "../Shared/Footer/Footer";
import Specialities from "../Home/Specialities/Specialities";
import OurSpecialists from "../Home/OurSpecialists/OurSpecialists";

const AboutUs = () => {
  return (
    <>
      <Header />
      <SubHeader title="O nas" subtitle="Oferujemy precyzyjną diagnozę bez kolejek, bez stresu i bez wychodzenia z domu." />
      <div style={{backgroundColor:"#f9f9f9", paddingTop:"3rem", paddingBottom:"1rem"}}>
        <div className="mb-5 section-title text-center">
          <h2>Klika słów o nas</h2>
          <p className="m-0">
            Poznaj naszą misję i motywację działania.
          </p>
        </div>
        <div className="about-us-ticks">
          <ul className="synavie-points">
            <li>
              <span className="title">
                Dostęp do rzetelnej diagnozy psychologicznej
              </span>
              <p>
                W Synavie wierzymy, że dostęp do rzetelnej diagnozy psychologicznej powinien być szybki, wygodny 
                i bezpieczny. Tworzymy nowoczesną przestrzeń, w której doświadczeni specjaliści wspierają osoby 
                potrzebujące profesjonalnej diagnozy, niezależnie od miejsca zamieszkania.
              </p>
            </li>
            <li>
              <span className="title">
                Przejrzysty proces diagnostyczny
              </span>
              <p>
                Naszym celem jest budowanie klarowności – oferujemy przejrzysty proces diagnostyczny, oparty na 
                aktualnej wiedzy, empatii i szacunku dla indywidualnych historii.
              </p>
            </li>
            <li>
              <span className="title">
                Kompleksowa diagnostyka specjalistyczna online
              </span>
              <p>
                Synavie to odpowiedź na rosnące potrzeby w zakresie diagnostyki ADHD, zaburzeń lękowych, 
                osobowościowych i neurorozwojowych – całkowicie online, z zachowaniem najwyższych standardów 
                etycznych i merytorycznych.
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div className="about-us-wrapper">
        <Specialities />
      </div>
      <div className="about-us-wrapper">
        <OurSpecialists />
      </div>
      <Process />
      <ContactUs />
      <Footer />
    </>
  );
};

export default AboutUs;